// extracted by mini-css-extract-plugin
export default {"root":"_1iF-k","item":"_2lYiR","link":"rwyhR"};